import ProjectToolsForm from './forms/step2/ProjectToolsForm';
import { useProjectId } from 'domain/shared/project';

const ProjectToolsLayout = () => {
  const projectId = useProjectId();

  return <ProjectToolsForm projectId={projectId} />;
};

export default ProjectToolsLayout;
